/**
 * Web Core Design System tokens
 */
export const fonts = {
  primary: 'var(--wcds-font-primary)',
  secondary: 'var(--wcds-font-secondary)',
  arabic: 'var(--wcds-font-arabic)',
  japanese: 'var(--wcds-font-japanese)',
}

export default {
  ...fonts,
  /**
   * @deprecated - use `secondary` instead
   */
  formular: fonts.secondary,
  /**
   * @deprecated - use `primary` instead
   */
  spoof: fonts.primary,
  /**
   * @deprecated - use `japanese` instead
   */
  mPlus1: fonts.japanese,
  /**
   * @deprecated - use `arabic` instead
   */
  vazirmatn: fonts.arabic,
}
